import { EventApi } from "@app/data/eventsSubscription/types";
import {
  usePrivateEventSubscriptionMutation,
  usePublicEventSubscriptionMutation,
  usePrivateEventDeclineMutation,
  usePublicEventDeclineMutation
} from "@app/data/eventsSubscription/api";


export const useEventApi = (): EventApi => {
  const [publicReq] = usePublicEventSubscriptionMutation()
  const [privateReq] = usePrivateEventSubscriptionMutation()
  const [privateDecline] = usePrivateEventDeclineMutation()
  const [publicDecline] = usePublicEventDeclineMutation()

  return {
    participant: {
      requestPublic:  async (eventId: string | number, userId: string | number) => {
        return await publicReq({ eventId, userId }).unwrap()
      },
      requestPrivate: async (eventId: string | number, userId: string | number) => {
        return await  privateReq({ eventId, userId}).unwrap();
      }
    }
  }
}